import { render, staticRenderFns } from "./label-tag-detail-table.vue?vue&type=template&id=9ba8d942&"
import script from "./label-tag-detail-table.vue?vue&type=script&lang=js&"
export * from "./label-tag-detail-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports